export const PRICE_LAYOUT = {
  COMPACT: "compact",
  DEFAULT: "default",
};

export const PRICE_SIZE = {
  XS: "xs",
  S: "s",
  M: "m",
  M_L: "m_l",
  L_M: "l_m",
  L: "l",
  XL: "xl",
  XXL: "xxl",
  XXXL: "xxxl",
};

export const PRICE_DECORATION = {
  LINE_THROUGH: "line-through",
  UNDERLINE: "underline",
  NONE: "",
};